import axios from '@src/utils/axios'

const axiosInstance = axios(false);

export default {
  'dashboard': () => axiosInstance.get('/dashboard')
}